var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 98.795,
    viewBox: "0 0 97 98.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agreement_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "x9hs8puf7a",
    x: 0,
    y: 0,
    width: 78.596,
    height: 98.795,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9 3.398)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#x9hs8puf7a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "file-contract-solid",
    d: "M10.1 0A10.109 10.109 0 0 0 0 10.1v60.6a10.109 10.109 0 0 0 10.1 10.1h40.4a10.109 10.109 0 0 0 10.1-10.1V25.248H40.4a5.044 5.044 0 0 1-5.05-5.05V0zm30.3 0v20.2h20.2zM12.624 10.1h10.1a2.525 2.525 0 1 1 0 5.05h-10.1a2.525 2.525 0 1 1 0-5.05zm0 10.1h10.1a2.525 2.525 0 1 1 0 5.05h-10.1a2.525 2.525 0 1 1 0-5.05zm8.553 40.05a7.58 7.58 0 0 1-7.259 5.4h-1.294a2.525 2.525 0 0 1 0-5.05h1.294a2.5 2.5 0 0 0 2.414-1.8l2.351-7.811a4.214 4.214 0 0 1 8.079 0l1.831 6.091a6.611 6.611 0 0 1 10.147 2.13l.694 1.389h8.537a2.525 2.525 0 1 1 0 5.05h-10.1a2.513 2.513 0 0 1-2.257-1.389l-1.389-2.793a1.553 1.553 0 0 0-1.389-.868 1.536 1.536 0 0 0-1.389.868l-1.389 2.793a2.521 2.521 0 0 1-4.671-.395l-2.667-8.79z",
    transform: "translate(9 5.998)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementIcon);
export default __webpack_public_path__ + "static/media/agreement_icon.5c9bed3547e5d722343dffc0d3204b2a.svg";
export { ForwardRef as ReactComponent };